import styled from 'styled-components';

export const Error = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.input.errorColor};
`;